import React from 'react';
import alertTypes from '../../shared/alertTypes';
import { MdWarning as WarningIcon } from 'react-icons/md';
import FormAlert from '../../shared/forms/formAlert.component';


const Content = () => (
  <div>
    <div><WarningIcon /> Warning!</div>
    <div>You are changing tax currency for a BSM Enabled Company Code.</div>
    <div>All existing BSM balances must be cleared prior to changing tax currency.</div>
  </div>
);

const ContentHomeOfficeCode = () => (
  <div>
    <div><WarningIcon /> Warning!</div>
    <div>
      To properly clear the US balances, edit all associated US tax rates to 0% and complete a
      successful calculation prior to making this change to Secondary Tax, or disable the US Obligations instead.
    </div>
  </div>
);

const EditCurrencyCodeAlertContent = ({ hidden }: { hidden: boolean }) => (
  <FormAlert content={<Content />} type={alertTypes.WARNING} hidden={hidden} />
);

const EditHomeOfficeCodeAlertContent = ({ hidden }: { hidden: boolean }) => (
  <FormAlert content={<ContentHomeOfficeCode />} type={alertTypes.WARNING} hidden={hidden} />
);


export { EditCurrencyCodeAlertContent, EditHomeOfficeCodeAlertContent };
